import React, { useEffect, useState, useContext, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import { format } from "date-fns";
import axios from "axios";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { AuthContext } from "../../helpers/AuthContext";
import ProfileLeftSidebar from "./ProfileLeftSidebar";
import CancelIcon from '@mui/icons-material/Cancel';

function PaymentMethods() {
  const { authState } = useContext(AuthContext);
  const [paymentMethods, setPaymentMethods] = useState(null);
  const [loading, setLoading] = useState(true)
  const [noPaymentsLoading, setNoPaymentsLoading] = useState(true);
  const [stripeCustomerDetails, setStripeCustomerDetails] = useState(null);

  let history = useHistory();
  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    } else {
      axios
        .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/${authState.id}/retrieve-payment-methods`, {
          headers: { accessToken: localStorage.getItem("accessToken") },
        })
        .then((response) => {
          if(response.data.data != ""){
            setPaymentMethods(response.data.data)
            axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/${authState.id}/retrieve-stripe-user-details`, {
              headers: { accessToken: localStorage.getItem("accessToken") },
            }).then((stripeCustomer) => {
              setStripeCustomerDetails(stripeCustomer.data);
            })
            setLoading(false)
          }
        }).catch((err) => {
          setNoPaymentsLoading(false)
        });
    }
  }, [authState.id]);
  return (
    <div className="ec-app-instances">
      <ProfileLeftSidebar/>
      <div className="rightSide">
      { loading == false ?
      <div className="options-container fade-in-effect-usability">
        <div className="options-inner-container">
        <h1 className="main-page-heading">Your payment methods</h1>
        <span className="main-page-description">Below our your payment methods on file.</span>
        <div className="action-bar">
          <a className="action-button add-payment-method">Add payment methods</a>
        </div>
        <div className="app-instance-list">
        {paymentMethods &&
          paymentMethods.map((method) => (
          <div className="instance">
            <div className="instance-inner-container">
              <div className="ec-payment-method-details">
                <div className="payment-method-credit-card-icon"><CreditCardIcon/></div>
                <div className="instance-heading">{method.card.brand} **** {method.card.last4}</div>
                <div className="instance-type-of-core">Expires{" "} {format(new Date(`${method.card.exp_year}/${method.card.exp_month}/01`), "MM/yyyy")}</div>
                <div className="delete-payment-method"><CancelIcon/></div>
                
                {
                stripeCustomerDetails != undefined ?
                  method.id == stripeCustomerDetails.invoice_settings.default_payment_method ?
                    <span className="fade-in-effect preferred-payment-method">Preferred</span>
                  : ""
                : ""
                }
              </div>
            </div>
          </div>
          ))
        }
        </div>
        </div>
      </div>
      : 
        noPaymentsLoading == false ?
        <div className="options-container fade-in-effect-usability">
          <div className="options-inner-container">
            <div className="options options-no-header-or-footer">
              <h2>No payment methods</h2>
              <p>You must add a payment method to your first live core before you are able to launch any more instances. <Link to="/">Click here to return to your main dashboard</Link>, and select the "Add to site" or "Get started" options under your first live core. </p>
            </div>
          </div>
        </div>  
        : "" 
      }
      </div>
    </div>
  );
}

export default PaymentMethods;
